export const getName = (event, $questionSet) => {
  $questionSet =
    $questionSet || event.currentTarget.closest('.js-quizQuestionSet');
  return $questionSet.dataset.name;
};
